import { useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { NuevoListadoEntrega } from '../connections/comun/ListadoEntregaConnection';

interface Props {
    openDialog: boolean;
    handleCloseDialog: () => void;
}

type TipoBusquedaType = '' | 'Generar nuevo listado de entrega' | 'Consultar listados de entrega';

export const DialogNuevoListadoEntrega = ({ openDialog, handleCloseDialog }: Props) => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [tipoBusqueda, setTipoBusqueda] = useState<TipoBusquedaType>('');

    const handleGenerarListaAcuerdos = async () => {

        setLoadingGuardar(true);

        if (tipoBusqueda === 'Generar nuevo listado de entrega') {

            await NuevoListadoEntrega().then(resp => {

                const { idListadoEntrega, success, message } = resp

                if (success) {

                    setTimeout(() => {

                        setLoadingGuardar(false);

                        navigate(`/listado-entrega/generar/` + idListadoEntrega);

                    }, 700);

                } else {

                    setTimeout(() => {

                        setLoadingGuardar(false);

                        dispatch(openSnackbar({ message: message, variant: 'error' }));

                    }, 700);
                }

            })

        }
        else if (tipoBusqueda === 'Consultar listados de entrega') {

            setTimeout(() => {

                setLoadingGuardar(false);

                navigate('/listado-entrega/consultar/');

            }, 700);

        }
    }

    const handleCerrarDialog = () => {

        setTipoBusqueda('');
        handleCloseDialog();

    }

    return (
        <>

            <Dialog
                maxWidth='md'
                open={openDialog}
                fullWidth={true}
            >

                <DialogTitle>Listado de entrega</DialogTitle>

                <DialogContent>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Seleccione una opción:</FormLabel>
                                <RadioGroup row>

                                    <FormControlLabel
                                        label='Generar nuevo listado de entrega'
                                        control={
                                            <Radio
                                                checked={tipoBusqueda === 'Generar nuevo listado de entrega'}
                                                onChange={() => setTipoBusqueda('Generar nuevo listado de entrega')}
                                            />
                                        }
                                    />

                                    <FormControlLabel
                                        label='Consultar listados de entrega'
                                        control={
                                            <Radio
                                                checked={tipoBusqueda === 'Consultar listados de entrega'}
                                                onChange={() => setTipoBusqueda('Consultar listados de entrega')}
                                            />
                                        }
                                    />

                                </RadioGroup>

                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={loadingGuardar} onClick={handleCerrarDialog}>Cancelar</Button>

                    <Button
                        variant="contained"
                        loading={loadingGuardar}
                        onClick={handleGenerarListaAcuerdos}
                        disabled={tipoBusqueda === ''}
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    )
}